let urlToPreload, mouseoverTimer, lastTouchTimestamp;
const prefetcher = document.createElement("link");
const isSupported = prefetcher.relList && prefetcher.relList.supports && prefetcher.relList.supports("prefetch");
const isDataSaverEnabled = navigator.connection && navigator.connection.saveData;
const allowQueryString = "instantAllowQueryString" in document.body.dataset;
const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;

if (isSupported && !isDataSaverEnabled) {
  prefetcher.rel = "prefetch";
  document.head.appendChild(prefetcher);
  const e = { capture: true, passive: true };
  document.addEventListener("touchstart", touchstartListener, e);
  document.addEventListener("mouseover", mouseoverListener, e);
}

function touchstartListener(e) {
  lastTouchTimestamp = performance.now();
  const t = e.target.closest("a");
  if (isPreloadable(t)) {
    t.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: true });
    t.addEventListener("touchend", touchendAndTouchcancelListener, { passive: true });
    urlToPreload = t.href;
    preload(t.href);
  }
}

function touchendAndTouchcancelListener() {
  urlToPreload = void 0;
  stopPreloading();
}

function mouseoverListener(e) {
  if (performance.now() - lastTouchTimestamp < 1100) return;
  const t = e.target.closest("a");
  if (isPreloadable(t)) {
    t.addEventListener("mouseout", mouseoutListener, { passive: true });
    urlToPreload = t.href;
    mouseoverTimer = setTimeout(() => {
      preload(t.href);
      mouseoverTimer = void 0;
    }, 65);
  }
}

function mouseoutListener(e) {
  if (e.relatedTarget && e.target.closest("a") === e.relatedTarget.closest("a")) return;
  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = void 0;
  } else {
    urlToPreload = void 0;
    stopPreloading();
  }
}

function isPreloadable(e) {
  if (!e || !e.href) return false; // Updated to return false instead of void 0
  if (urlToPreload === e.href) return false;
  
  const t = new URL(e.href);
  return !(!(allowExternalLinks || t.origin === location.origin || "instant" in e.dataset) ||
    !["http:", "https:"].includes(t.protocol) ||
    (t.protocol === "http:" && location.protocol === "https:") ||
    (t.protocol === "https:" && location.protocol === "http:") ||
    !(allowQueryString || !t.search || "instant" in e.dataset) ||
    (t.hash && t.pathname + t.search === location.pathname + location.search) ||
    "noInstant" in e.dataset);
}

function preload(e) {
  prefetcher.href = e;
}

function stopPreloading() {
  prefetcher.removeAttribute("href");
}
